import { Injectable } from '@angular/core';
import { BaseApiService } from '@app/api/base_api';
import { MeterLocation } from '../types';

@Injectable()
export class MeterLocationService extends BaseApiService<MeterLocation> {
  component: string = 'meterlocation';
}
